import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    pro: PropTypes.bool,
    premium: PropTypes.bool,
    inner: PropTypes.bool,
    color: PropTypes.bool,
    column: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    pro: false,
    premium: false,
    inner: false,
    color: false,
    column: false,
};

class Advert extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            pro,
            premium,
            inner,
            color,
            column,
        } = this.props;
        return [
            'c-advert',
            pro ? 'c-advert--pro' : null,
            premium ? 'c-advert--premium' : null,
            inner ? 'c-advert--inner' : null,
            color ? 'c-advert--color' : null,
            column ? 'c-advert--column' : null,
            className,
        ];
    }

}

Advert.propTypes = propTypes;

Advert.defaultProps = defaultProps;

export default Advert;
